import * as React from 'react'

const SvgAdminCoursesIcon = ({ stroke }) => (
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.57181 19.2002C7.90661 18.56 9.40997 18.2002 11 18.2002C12.59 18.2002 14.0934 18.56 15.4282 19.2002M5.8 15.2002H16.2C17.8802 15.2002 18.7202 15.2002 19.362 14.8732C19.9265 14.5856 20.3854 14.1267 20.673 13.5622C21 12.9204 21 12.0804 21 10.4002V6.0002C21 4.32004 21 3.47996 20.673 2.83822C20.3854 2.27374 19.9265 1.8148 19.362 1.52718C18.7202 1.2002 17.8802 1.2002 16.2 1.2002H5.8C4.11984 1.2002 3.27976 1.2002 2.63803 1.52718C2.07354 1.8148 1.6146 2.27374 1.32698 2.83822C1 3.47996 1 4.32004 1 6.0002V10.4002C1 12.0804 1 12.9204 1.32698 13.5622C1.6146 14.1267 2.07354 14.5856 2.63803 14.8732C3.27976 15.2002 4.11984 15.2002 5.8 15.2002Z"
      stroke={stroke || '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgAdminCoursesIcon
